import { Controller } from "@hotwired/stimulus";
import IMask from "imask";

const CURRENCY_MASK = {
  mask: '$num',
  lazy: false,
  blocks: {
    num: {
      mask: Number,
      scale: 2,
      thousandsSeparator: ',',
      padFractionalZeros: true,
      radix: '.',
      mapToRadix: ['.']
    }
  }
}

const NUMBER_MASK = {
  mask: 'num',
  lazy: false,
  blocks: {
    num: {
      mask: Number,
      scale: 0,
      thousandsSeparator: ','
    }
  }
}

export default class extends Controller {
  static values = {
    format: { type: String, default: "number" }
  }

  connect() {
    this.#attachEventListeners();
    this.#attachMask();
  }

  disconnect() {
    this.mask?.destroy();
    this.#removeEventListeners();
  }

  #attachEventListeners() {
    this.element.form.addEventListener("submit", this.#handleSubmit.bind(this));
  }

  #attachMask() {
    let selectedMask = NUMBER_MASK;

    if (this.formatValue == "currency") {
      selectedMask = CURRENCY_MASK;
    }

    this.mask = new IMask(
      this.element,
      {
        mask: [
          { mask: '' },
          selectedMask
        ]
      }
    );
  }

  #handleSubmit(event) {
    this.element.value = this.mask.unmaskedValue;
  }

  #removeEventListeners() {
    this.element.form.removeEventListener("submit", this.#handleSubmit.bind(this));
  }
}
